import ascend from "ramda/src/ascend";
import sort from "ramda/src/sort";
import * as React from "react";
import { useCallback } from "react";
import {
  FilterQuery,
  ParameterFilterOption,
} from "../../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { AppliedFilter } from "../applied_filter/applied_filter";
import { Filter } from "../applied_filter/filter";
import {
  serializedFalseValue,
  serializedTrueValue,
} from "../helpers/filter_url_serialization";
import { removeBooleanParameterFilter } from "../helpers/handle_remove_filter";

const filterKey: keyof FilterQuery = "booleanParameters";
const serializedKey = "parametryAnoNe";

const parameterValueRegexp = new RegExp(
  `^(\\d+)\\[(${serializedTrueValue}|${serializedFalseValue})]\$`
);

export const BooleanParametersFilter: Filter = {
  key: "booleanParameters",
  serialize: (appliedFilter) => {
    if (appliedFilter.booleanParameters === undefined) {
      return null;
    }
    const serializedValues = sort(
      ascend(([parameterId]) => parameterId),
      Object.entries(appliedFilter.booleanParameters)
    )
      .map(
        ([parameterId, value]) =>
          `${parameterId}[${
            value ? serializedTrueValue : serializedFalseValue
          }]`
      )
      .join(",");

    return `${serializedKey}=${serializedValues}`;
  },
  deserialize: (urlSearchParams: URLSearchParams) => {
    const serializedValues = urlSearchParams.get(serializedKey);

    const booleanParameters: FilterQuery["booleanParameters"] = {};
    if (serializedValues !== null) {
      serializedValues.split(",").forEach((serializedValue) => {
        const match = serializedValue.match(parameterValueRegexp);
        if (match) {
          booleanParameters[parseInt(match[1])] =
            match[2] === serializedTrueValue;
        }
      });
    }

    return Object.keys(booleanParameters).length > 0
      ? { booleanParameters }
      : undefined;
  },
  AppliedControlComponent: ({ appliedFilter, filterOptions, onRemove }) => {
    const booleanParametersFilter = appliedFilter[filterKey];

    const handleRemove = useCallback(
      (parameterId?: number) => {
        onRemove({
          ...appliedFilter,
          booleanParameters: removeBooleanParameterFilter(
            appliedFilter.booleanParameters,
            parameterId as number
          ),
        });
      },
      [onRemove]
    );

    const validAppliedBooleanFilters = sort(
      ascend(
        (key) => filterOptions.parametersById[parseInt(key)]?.sortOrderInFilter
      ),
      Object.keys(booleanParametersFilter ?? {})
    )
      .map(
        (parameterId) =>
          filterOptions.parametersById[
            parseInt(parameterId)
          ] as ParameterFilterOption
      )
      .filter(Boolean);

    if (
      booleanParametersFilter === undefined ||
      validAppliedBooleanFilters.length === 0
    ) {
      return null;
    }

    return (
      <>
        {validAppliedBooleanFilters.map((booleanParameter) => (
          <AppliedFilter
            key={booleanParameter.id}
            filterName={booleanParameter.name}
            values={[
              {
                name:
                  booleanParametersFilter[booleanParameter.id] === true
                    ? "ano"
                    : "ne",
                id: booleanParameter.id,
              },
            ]}
            onRemove={handleRemove}
          />
        ))}
      </>
    );
  },
};
